import React from "react";
import { Row, Col } from "shards-react";
import PropTypes from "prop-types";
import ConfigurationsCardComponent from "./configurations-card-component/ConfigurationsCardComponent";

const CheckBoxGroupComponent = props => {
    const {
        options: {
            miniApp,
            miniApp: { status, visible },
            hasWriteMiniAppScope,
            hasWriteMiniAppAction
        },
        handleSwitchStatus,
        handleSwitchChange
    } = props;

    const configurations = [status, visible];

    return (
        <Row>
            <Col sm="12" lg="6">
                <ConfigurationsCardComponent
                    miniApp={miniApp}
                    configurations={configurations || []}
                    handleSwitchStatus={handleSwitchStatus}
                    handleSwitchChange={handleSwitchChange}
                    hasWriteMiniAppScope={hasWriteMiniAppScope}
                    hasWriteMiniAppAction={hasWriteMiniAppAction}
                />
            </Col>
        </Row>
    );
};

CheckBoxGroupComponent.propTypes = {
    options: PropTypes.object,
    miniApp: PropTypes.object,
    permissions: PropTypes.array,
    status: PropTypes.string,
    visible: PropTypes.bool,
    isEditScreen: PropTypes.bool,
    handleSwitchStatus: PropTypes.func,
    handleSwitchChange: PropTypes.func,
    onTogglePermission: PropTypes.func
};

export default CheckBoxGroupComponent;
